// extracted by mini-css-extract-plugin
export default {"root":"CampaignButton_root__sXfLu"};